import React from "react";
import Select from "react-select";
import { hexAlpha } from "../../types";
import { EMPLOYMENT_TYPE_OPTIONS } from "../../../constants/recruitment.constants";

interface JobFiltersProps {
  primaryColor: string;
  type: string | null;
  setType: (val: string | null) => void;
  searchQuery: string;
  jobsLength: number;
  viewMode: "grid" | "list";
  setViewMode: (val: "grid" | "list") => void;
  onSubscribeAlerts: () => void;
}

const JobFilters: React.FC<JobFiltersProps> = ({
  primaryColor,
  type,
  setType,
  searchQuery,
  jobsLength,
  viewMode,
  setViewMode,
  onSubscribeAlerts,
}) => {
  return (
    <div style={{
      background: "#fff",
      borderBottom: "1px solid #e8eaed",
      padding: "14px 40px",
      display: "flex", alignItems: "center", justifyContent: "space-between",
      flexWrap: "wrap", gap: 12,
      position: "sticky", top: 64, zIndex: 90,
      boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
    }}>
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <div style={{ width: 220 }}>
          <Select
            options={EMPLOYMENT_TYPE_OPTIONS}
            placeholder="All Job Types"
            isClearable
            onChange={(opt: any) => setType(opt?.value || null)}
            classNamePrefix="react-select"
            styles={{
              control: (base: any) => ({
                ...base, borderRadius: 8, border: "1px solid #e2e8f0",
                fontSize: 13, minHeight: 36, boxShadow: "none",
                "&:hover": { borderColor: primaryColor },
              }),
              option: (base: any, state: any) => ({
                ...base, fontSize: 13,
                backgroundColor: state.isSelected ? primaryColor : state.isFocused ? hexAlpha(primaryColor, 0.08) : "#fff",
              }),
            }}
          />
        </div>
        {(searchQuery || type) && (
          <span style={{ fontSize: 13, color: "#888" }}>
            {jobsLength} result{jobsLength !== 1 ? "s" : ""}
          </span>
        )}
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        
        <div style={{
          display: "flex", background: "#f4f5f7",
          borderRadius: 8, padding: 3, gap: 2,
        }}>
          {(["grid", "list"] as const).map((mode) => (
            <button
              key={mode}
              onClick={() => setViewMode(mode)}
              style={{
                display: "flex", alignItems: "center", gap: 5,
                padding: "5px 14px", borderRadius: 6, border: "none",
                background: viewMode === mode ? "#fff" : "transparent",
                color: viewMode === mode ? primaryColor : "#888",
                fontSize: 13, fontWeight: viewMode === mode ? 600 : 400,
                cursor: "pointer",
                boxShadow: viewMode === mode ? "0 1px 4px rgba(0,0,0,0.1)" : "none",
                transition: "all 0.15s",
              }}
            >
              <i className={`ti ti-layout-${mode === "grid" ? "grid" : "list"}`} />
              {mode.charAt(0).toUpperCase() + mode.slice(1)}
            </button>
          ))}
        </div>

        
        <button
          onClick={onSubscribeAlerts}
          style={{
            display: "flex", alignItems: "center", gap: 6,
            padding: "7px 16px", borderRadius: 8,
            border: `1.5px solid ${primaryColor}`, background: "transparent",
            color: primaryColor, fontSize: 13, fontWeight: 600, cursor: "pointer",
          }}
        >
          <i className="ti ti-bell-ringing" /> Job Alerts
        </button>
      </div>
    </div>
  );
};

export default JobFilters;
